'use strict';

// Needed for Safari & IE
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

const SELECTOR = '.js-scroll-to';

export function init() {
	const links = document.querySelectorAll(SELECTOR);
	links.forEach(link => {
		link.addEventListener('click', scrollAnchors);
	});
}

function scrollAnchors(e, respond = null) {
	const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
	e.preventDefault();

	// If the full URL is there then strips everything prior to the hash
	const targetID = ((respond) ? respond.getAttribute('href') : this.getAttribute('href')).replace(/^[^#]*/, '');
	const targetAnchor = document.querySelector(targetID);

	if (!targetAnchor) return;

	var originalTop = distanceToTop(targetAnchor);
	var scrollOffset = this.dataset.scrollOffset;

	if (scrollOffset) {
		originalTop = (originalTop - scrollOffset)
	}
	window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });
}